import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { getRequest } from '../../helpers/apiHandler';
import config from '../../config/Constant';
import uploadIcon from '../../assets/SidebarIcons/icon-upload.svg';
import GlobalRatesUploadModel from './GlobalRatesUploadModel';
import GlobalRatesUpdateModel from './GlobalRatesUpdateModel';
import ListPage from '../ListPage';

const GlobalRates = () => {
  const { access_token } = useSelector((state) => state.auth.user);
  const [loadingData, setLoadingData] = useState(false);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [columns, setColumns] = useState([]);

  const [selectedData, setSelectedData] = useState({});
  const [showUpdateModel, setShowUpdateModel] = useState(false);
  const [showUploadModel, setShowUploadModel] = useState(false);

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const getGlobalRatesData = () => {
    setLoadingData(true);
    const data = { headers: { Authorization: access_token.token } };
    getRequest(`/admin/global-rates`, data, (res) => {
      if (res.success) {
        const result = res.data;
        setData(result);
        setSearchData(result);
        generateColumns(result);
      } else {
        setAlertState({
          message: 'There was an issue while fetching global rates',
          show: true,
          variant: 'danger',
        });
      }
      setLoadingData(false);
    });
  };

  const generateColumns = (data) => {
    if (data.length > 0) {
      const generateColumns = [
        { name: 'Country Code', sortable: true, selector: (row) => row.country },
        { name: 'Country', sortable: true, selector: (row) => row.name },
        { name: 'Cost (MYR)', sortable: true, selector: (row) => row.myr_cost },
        { name: 'Cost (USD)', sortable: true, selector: (row) => row.usd_cost },
        { name: 'Cost (EUR)', sortable: true, selector: (row) => row.eur_cost },
        {
          name: 'Actions',
          sortable: true,
          selector: (row) => (
            <div className="d-flex justify-content-center align-items-center gap-1">
              <Button variant="primary" onClick={() => openModal(row)} style={{ minWidth: 100 }}>
                Edit
              </Button>
            </div>
          ),
        },
      ];
      setColumns(generateColumns);
    }
  };

  const openModal = (rowData) => {
    setSelectedData(rowData);
    setShowUpdateModel(true);
  };

  const onSearch = (evt) => {
    const { value } = evt.target;
    const filteredData = data.filter(
      (item) =>
        item.name.toLowerCase().includes(value.toLowerCase()) ||
        item.country.toLowerCase().includes(value.toLowerCase())
    );

    setSearch(value);
    setSearchData(value ? filteredData : data);
  };

  useEffect(() => {
    getGlobalRatesData();
  }, []);

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <ListPage
      title="Global Rates"
      search={search}
      onSearch={onSearch}
      alert={alertState}
      setAlert={setAlertState}
      columns={columns}
      data={searchData}
      loading={loadingData}
      actions={
        <>
          <Button
            variant="primary"
            style={{ minWidth: 160 }}
            onClick={() => setShowUploadModel(true)}
          >
            <img src={uploadIcon} alt="..." style={{ marginRight: 8 }} />
            Upload File
          </Button>
        </>
      }
    >
      <GlobalRatesUpdateModel
        show={showUpdateModel}
        onClose={() => setShowUpdateModel(false)}
        rowData={selectedData}
        getGlobalRatesData={getGlobalRatesData}
      />
      <GlobalRatesUploadModel
        show={showUploadModel}
        onClose={() => setShowUploadModel(false)}
        getGlobalRatesData={getGlobalRatesData}
      />
    </ListPage>
  );
};

export default GlobalRates;
